import React, { Component } from "react";
import Grid from "@material-ui/core/Grid";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Typography from "@material-ui/core/Typography";
import TextareaAutosize from "@material-ui/core/TextareaAutosize";
import Button from "@material-ui/core/Button";
import AutoForm from "react-auto-form";
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';

//import { ToastContainer, toast } from "react-toastify";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

//import { greenValue, orangeValue, redValue } from "../components/Enums.js";

export class O_Mr extends Component {

    //constructor(props) {
    //    super(props);
    //    this.state = {
    //        missionId: props.propMissionId,
    //        lastOnChange: null,
    //        lastOnSubmit: null,
    //        trim: true,
    //        trimOnSubmit: false,
    //        pageLoadData: {}
    //    };
    //}

    //_onChange = (e, name, data, change) => {
    //    console.log(data);
    //    this.setState({ lastOnChange: { name, data, change } });
    //};

    //_onSubmit = (e, data) => {
    //    console.log("submit");
    //    //console.log(data);
    //    this.setState({ lastOnSubmit: { data } });

    //    let dataToSubmit = data;
    //    dataToSubmit["missionId"] = this.state.missionId;
    //    dataToSubmit["templateId"] = 1;
    //    console.log(dataToSubmit);

    //    fetch(global.variables.API_TEMPLATEFILLER_FILLANSWERS, {
    //        method: "POST",
    //        headers: {
    //            Authorization: "Bearer " + localStorage.getItem("authtoken"),
    //            Accept: "application/json",
    //            "Content-Type": "application/json"
    //        },
    //        body: JSON.stringify(dataToSubmit)
    //    })
    //        .then(response => response.json())
    //        .then(result => {
    //            console.log(result);
    //        });

    //    e.preventDefault();
    //};

    //_onOptionsChange = (e, name, data, change) => {
    //    console.log(data);
    //    this.setState(change);
    //};

    //async componentDidMount() {
    //    await fetch(global.variables.API_TEMPLATEFILLER_GETANSWERS, {
    //        method: "POST",
    //        headers: {
    //            Authorization: "Bearer " + localStorage.getItem("authtoken"),
    //            Accept: "application/json",
    //            "Content-Type": "application/json"
    //        },
    //        body: JSON.stringify({
    //            operation: "GetOnGoingMr",
    //            missionId: this.state.missionId,
    //            templateId: 1 // MR
    //        })
    //    })
    //        .then(response => response.json())
    //        .then(result => {
    //            console.log(result);

    //            if (result.saveddata.length > 0) {
    //                this.setState({ pageLoadData: JSON.parse(result.saveddata[0].TemplateAnswers) });
    //            }
    //        });

    //    //console.log(this.state.pageLoadData);
    //    //console.log(this.state.pageLoadData.OmrQ1Context);
    //    //this.forceUpdate();
    //}

    ////handleSave = () => {
    ////    //console.log("ID: " + this.state.projectId);

    ////    for (var key in this.state) {
    ////        console.log(key + ": " + this.state[key]);
    ////    }
    ////};

    //render() {
    //    //let { lastOnChange, lastOnSubmit, trim, trimOnSubmit } = this.state;
    //    let { trim, trimOnSubmit } = this.state;

    constructor(props) {
        super(props);
        this.state = {
            missionId: props.propMissionId,
            lastOnChange: null,
            lastOnSubmit: null,
            trim: false,
            trimOnSubmit: false,
            pageLoadData: {},
            templateId: props.propTemplateId,
            countConclusions: 1,
            countRecommendations: 1
        };
    }

    _onChange = (e, name, data, change) => {
        console.log(data)

        var pageLoadDataChange = this.state.pageLoadData;
        pageLoadDataChange[name] = data;

        this.setState({
            lastOnChange: { name, data, change },
            pageLoadData: pageLoadDataChange
        });

    }

    _onSubmit = (e, data) => {
        console.log("submit");
        this.setState({ lastOnSubmit: { data } });

        let dataToSubmit = data;
        dataToSubmit["missionId"] = this.state.missionId;
        dataToSubmit["templateId"] = this.state.templateId;
        dataToSubmit["countConclusions"] = this.state.countConclusions;
        dataToSubmit["countRecommendations"] = this.state.countRecommendations;
        console.log(dataToSubmit);

        //this.props.propPageLoadData = dataToSubmit;
        this.props.propUpdatePageLoadData(dataToSubmit);

        fetch(global.variables.API_TEMPLATEFILLER_FILLANSWERS, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(dataToSubmit)
        })
            .then(response => response.json())
            .then(result => {
                console.log(result);

                if (result.resultstate === 0) {
                    toast.success("Success!", {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });
                } else {
                    toast.error("Failed!", {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });
                }
            });

        e.preventDefault();
    }

    _onOptionsChange = (e, name, data, change) => {
        console.log(data);
        this.setState(change);
    };

    async componentDidMount() {
        await fetch(global.variables.API_TEMPLATEFILLER_GETANSWERS, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                operation: "GetExpostMq",
                missionId: this.state.missionId,
                templateId: this.state.templateId
            })
        })
            .then(response => response.json())
            .then(result => {
                console.log(result);

                if (result.saveddata.length > 0) {
                    this.setState({ pageLoadData: JSON.parse(result.saveddata[0].TemplateAnswers) });

                    if (JSON.parse(result.saveddata[0].TemplateAnswers).countConclusions !== undefined &&
                        JSON.parse(result.saveddata[0].TemplateAnswers).countConclusions > 0) {
                        this.setState({
                            countConclusions: JSON.parse(result.saveddata[0].TemplateAnswers).countConclusions,
                        });
                    } else {
                        this.setState({
                            countConclusions: 1,
                        });
                    }

                    if (JSON.parse(result.saveddata[0].TemplateAnswers).countRecommendations !== undefined &&
                        JSON.parse(result.saveddata[0].TemplateAnswers).countRecommendations > 0) {
                        this.setState({
                            countRecommendations: JSON.parse(result.saveddata[0].TemplateAnswers).countRecommendations,
                        });
                    } else {
                        this.setState({
                            countRecommendations: 1,
                        });
                    }

                }
            });

        //this.props.propPageLoadData = this.state.pageLoadData;
        this.props.propUpdatePageLoadData(this.state.pageLoadData);

    }

    checkIfChecked = (element, value) => {
        if (element === value) {
            return true;
        } else {
            return false;
        }
    };

    incrementConclusions = () => {
        var countConclusions = this.state.countConclusions;

        if (countConclusions < 10) {
            countConclusions += 1;
        }

        this.setState({ countConclusions: countConclusions });
    }

    incrementRecommendations = () => {
        var countRecommendations = this.state.countRecommendations;

        if (countRecommendations < 10) {
            countRecommendations += 1;
        }

        this.setState({ countRecommendations: countRecommendations });
    }

    render() {
        let {
            trim,
            trimOnSubmit,
            pageLoadData,
            countConclusions,
            countRecommendations
        } = this.state;
        return (
            <Grid container direction="column">
                <AutoForm
                    onSubmit={this._onSubmit}
                    onChange={this._onChange}
                    trim={!!trim}
                    trimOnSubmit={!!trimOnSubmit}
                    style={{ width: "100%" }}
                >
                    <Grid item xs={12}>

                        <p>Scoring</p>
                        <ExpansionPanel style={{ width: "50%" }}>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography>Relevance</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="OmrS1Relevance" >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.OmrS1Relevance, "1")} control={<Radio />} className="green" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.OmrS1Relevance, "2")} control={<Radio />} className="orange" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.OmrS1Relevance, "3")} control={<Radio />} className="red" />
                                    </Grid>
                                </RadioGroup>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>
                        <ExpansionPanel style={{ width: "50%" }}>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography>Efficiency</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="OmrS2Efficiency" >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.OmrS2Efficiency, "1")} control={<Radio />} className="green" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.OmrS2Efficiency, "2")} control={<Radio />} className="orange" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.OmrS2Efficiency, "3")} control={<Radio />} className="red" />
                                    </Grid>
                                </RadioGroup>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>
                        <ExpansionPanel style={{ width: "50%" }}>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography>Effectiveness</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="OmrS3Effectiveness" >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.OmrS3Effectiveness, "1")} control={<Radio />} className="green" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.OmrS3Effectiveness, "2")} control={<Radio />} className="orange" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.OmrS3Effectiveness, "3")} control={<Radio />} className="red" />
                                    </Grid>
                                </RadioGroup>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>

                        {
                            //<ExpansionPanel style={{ width: "50%" }}>
                            //    <ExpansionPanelSummary
                            //        expandIcon={<ExpandMoreIcon />}
                            //        aria-controls="panel1a-content"
                            //        id="panel1a-header"
                            //    >
                            //        <Typography>Impact</Typography>
                            //    </ExpansionPanelSummary>
                            //    <ExpansionPanelDetails>
                            //        <RadioGroup aria-label="gender" name="OmrS4Impact" >
                            //            <Grid item xs direction="column">
                            //                <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.OmrS4Impact, "1")} control={<Radio />} className="green" />
                            //                <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.OmrS4Impact, "2")} control={<Radio />} className="orange" />
                            //                <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.OmrS4Impact, "3")} control={<Radio />} className="red" />
                            //            </Grid>
                            //        </RadioGroup>
                            //    </ExpansionPanelDetails>
                            //</ExpansionPanel>
                        }

                        <ExpansionPanel style={{ width: "50%" }}>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography>Sustainability</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="OmrS5Sustainability" >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.OmrS5Sustainability, "1")} control={<Radio />} className="green" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.OmrS5Sustainability, "2")} control={<Radio />} className="orange" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.OmrS5Sustainability, "3")} control={<Radio />} className="red" />
                                    </Grid>
                                </RadioGroup>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>

                        <br />
                        <p>Project Synopsis</p>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography> Context </Typography>
                            </ExpansionPanelSummary>

                            <ExpansionPanelDetails>
                                {
                                    //<Grid item xs direction="column">
                                }
                                <Grid item xs>
                                    <TextareaAutosize
                                        rows={6}
                                        style={{ width: "100%" }}
                                        name="OmrQ1Context"
                                        defaultValue={this.state.pageLoadData.OmrQ1Context}
                                    />
                                </Grid>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography>Description of the Intervention Logic </Typography>
                            </ExpansionPanelSummary>

                            <ExpansionPanelDetails>
                                <Grid item xs>
                                    <TextareaAutosize
                                        rows={6}
                                        style={{ width: "100%" }}
                                        name="OmrQ2Description"
                                        defaultValue={this.state.pageLoadData.OmrQ2Description}
                                    />
                                </Grid>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>

                        <br />
                        <p>Findings</p>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography>Relevance </Typography>
                            </ExpansionPanelSummary>

                            <ExpansionPanelDetails>
                                <Grid item xs>
                                    <TextareaAutosize
                                        name="OmrQ3Relevance"
                                        rows={6}
                                        style={{ width: "100%" }}
                                        defaultValue={this.state.pageLoadData.OmrQ3Relevance}
                                    />
                                </Grid>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography>Efficiency</Typography>
                            </ExpansionPanelSummary>

                            <ExpansionPanelDetails>
                                <Grid item xs>
                                    <TextareaAutosize
                                        name="OmrQ4Efficiency"
                                        rows={6}
                                        style={{ width: "100%" }}
                                        defaultValue={this.state.pageLoadData.OmrQ4Efficiency}
                                    />
                                </Grid>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography> Effectiveness</Typography>
                            </ExpansionPanelSummary>

                            <ExpansionPanelDetails>
                                <Grid item xs>
                                    <TextareaAutosize
                                        name="OmrQ5Effectiveness"
                                        rows={6}
                                        style={{ width: "100%" }}
                                        defaultValue={this.state.pageLoadData.OmrQ5Effectiveness}
                                    />
                                </Grid>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography> Sustainability </Typography>
                            </ExpansionPanelSummary>

                            <ExpansionPanelDetails>
                                <Grid item xs>
                                    <TextareaAutosize
                                        name="OmrQ6Sustainability"
                                        rows={6}
                                        style={{ width: "100%" }}
                                        defaultValue={this.state.pageLoadData.OmrQ6Sustainability}
                                    />
                                </Grid>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>

                        <br />
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography>Conclusion</Typography>

                            </ExpansionPanelSummary>

                            <ExpansionPanelDetails style={{ display: countConclusions > 0 ? "block" : "none" }}>
                                <Grid item xs>
                                    <TextareaAutosize
                                        name="OmrQ7ConclusionsC1"
                                        rows={6}
                                        style={{ width: "100%", display: countConclusions > 0 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.OmrQ7ConclusionsC1}
                                    />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countConclusions > 1 ? "block" : "none" }}>
                                <Grid item xs>
                                    <TextareaAutosize
                                        name="OmrQ7ConclusionsC2"
                                        rows={6}
                                        style={{ width: "100%", display: countConclusions > 1 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.OmrQ7ConclusionsC2}
                                    />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countConclusions > 2 ? "block" : "none" }}>
                                <Grid item xs>
                                    <TextareaAutosize
                                        name="OmrQ7ConclusionsC3"
                                        rows={6}
                                        style={{ width: "100%", display: countConclusions > 2 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.OmrQ7ConclusionsC3}
                                    />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countConclusions > 3 ? "block" : "none" }}>
                                <Grid item xs>
                                    <TextareaAutosize
                                        name="OmrQ7ConclusionsC4"
                                        rows={6}
                                        style={{ width: "100%", display: countConclusions > 3 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.OmrQ7ConclusionsC4}
                                    />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countConclusions > 4 ? "block" : "none" }}>
                                <Grid item xs>
                                    <TextareaAutosize
                                        name="OmrQ7ConclusionsC5"
                                        rows={6}
                                        style={{ width: "100%", display: countConclusions > 4 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.OmrQ7ConclusionsC5}
                                    />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countConclusions > 5 ? "block" : "none" }}>
                                <Grid item xs>
                                    <TextareaAutosize
                                        name="OmrQ7ConclusionsC6"
                                        rows={6}
                                        style={{ width: "100%", display: countConclusions > 5 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.OmrQ7ConclusionsC6}
                                    />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countConclusions > 6 ? "block" : "none" }}>
                                <Grid item xs>
                                    <TextareaAutosize
                                        name="OmrQ7ConclusionsC7"
                                        rows={6}
                                        style={{ width: "100%", display: countConclusions > 6 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.OmrQ7ConclusionsC7}
                                    />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countConclusions > 7 ? "block" : "none" }}>
                                <Grid item xs>
                                    <TextareaAutosize
                                        name="OmrQ7ConclusionsC8"
                                        rows={6}
                                        style={{ width: "100%", display: countConclusions > 7 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.OmrQ7ConclusionsC8}
                                    />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countConclusions > 8 ? "block" : "none" }}>
                                <Grid item xs>
                                    <TextareaAutosize
                                        name="OmrQ7ConclusionsC9"
                                        rows={6}
                                        style={{ width: "100%", display: countConclusions > 8 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.OmrQ7ConclusionsC9}
                                    />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countConclusions > 9 ? "block" : "none" }}>
                                <Grid item xs>
                                    <TextareaAutosize
                                        name="OmrQ7ConclusionsC10"
                                        rows={6}
                                        style={{ width: "100%", display: countConclusions > 9 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.OmrQ7ConclusionsC10}
                                    />
                                </Grid>
                            </ExpansionPanelDetails>

                            <ExpansionPanelDetails>
                                <Grid item xs>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={this.incrementConclusions.bind(this)}
                                    >
                                        Add Conclusion
                                </Button>
                                </Grid>
                            </ExpansionPanelDetails>

                        </ExpansionPanel>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography>Recommendations</Typography>
                            </ExpansionPanelSummary>

                            <ExpansionPanelDetails style={{ display: countRecommendations > 0 ? "block" : "none" }}>
                                <Grid item xs>
                                    <TextareaAutosize
                                        name="OmrQ8Recommendations" rows={6}
                                        style={{ width: "100%", display: countRecommendations > 0 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.OmrQ8Recommendations}
                                    />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countRecommendations > 1 ? "block" : "none" }}>
                                <Grid item xs>
                                    <TextareaAutosize
                                        name="OmrQ9Recommendations2" rows={6}
                                        style={{ width: "100%", display: countRecommendations > 1 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.OmrQ9Recommendations2}
                                    />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countRecommendations > 2 ? "block" : "none" }}>
                                <Grid item xs>
                                    <TextareaAutosize
                                        name="OmrQ10Recommendations3" rows={6}
                                        style={{ width: "100%", display: countRecommendations > 2 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.OmrQ10Recommendations3}
                                    />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countRecommendations > 3 ? "block" : "none" }}>
                                <Grid item xs>
                                    <TextareaAutosize
                                        name="OmrQ11Recommendations4" rows={6}
                                        style={{ width: "100%", display: countRecommendations > 3 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.OmrQ11Recommendations4}
                                    />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countRecommendations > 4 ? "block" : "none" }}>
                                <Grid item xs>
                                    <TextareaAutosize
                                        name="OmrQ12Recommendations5" rows={6}
                                        style={{ width: "100%", display: countRecommendations > 4 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.OmrQ12Recommendations5}
                                    />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countRecommendations > 5 ? "block" : "none" }}>
                                <Grid item xs>
                                    <TextareaAutosize
                                        name="OmrQ13Recommendations6" rows={6}
                                        style={{ width: "100%", display: countRecommendations > 5 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.OmrQ13Recommendations6}
                                    />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countRecommendations > 6 ? "block" : "none" }}>
                                <Grid item xs>
                                    <TextareaAutosize
                                        name="OmrQ14Recommendations7" rows={6}
                                        style={{ width: "100%", display: countRecommendations > 6 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.OmrQ14Recommendations7}
                                    />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countRecommendations > 7 ? "block" : "none" }}>
                                <Grid item xs>
                                    <TextareaAutosize
                                        name="OmrQ15Recommendations8" rows={6}
                                        style={{ width: "100%", display: countRecommendations > 7 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.OmrQ15Recommendations8}
                                    />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countRecommendations > 8 ? "block" : "none" }}>
                                <Grid item xs>
                                    <TextareaAutosize
                                        name="OmrQ16Recommendations9" rows={6}
                                        style={{ width: "100%", display: countRecommendations > 8 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.OmrQ16Recommendations9}
                                    />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countRecommendations > 9 ? "block" : "none" }}>
                                <Grid item xs>
                                    <TextareaAutosize
                                        name="OmrQ17Recommendations10" rows={6}
                                        style={{ width: "100%", display: countRecommendations > 9 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.OmrQ17Recommendations10}
                                    />
                                </Grid>
                            </ExpansionPanelDetails>

                            <ExpansionPanelDetails>
                                <Grid item xs>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={this.incrementRecommendations.bind(this)}
                                    >
                                        Add Recommendation
                                </Button>
                                </Grid>
                            </ExpansionPanelDetails>

                        </ExpansionPanel>
                    </Grid>
                    <Grid item xs={12} style={{ textAlign: "center" }} className="mt-1">
                        <Button
                            variant="contained"
                            color="primary"
                            type="submit"
                        >
                            SAVE
                        </Button>
                    </Grid>
                </AutoForm>
            </Grid >
        );
    }
}



// WEBPACK FOOTER //
// ./src/pages/O_Mr.js